import { createRootRoute, createRoute, redirect } from '@tanstack/react-router';
import { AppLayout } from '#app/layouts';
import RootLayout from '#app/layouts/RootLayout.tsx';
import { verifySession } from '#domains/auth';
import { ErrorPage, LoaderPage } from '../pages';

export const rootRoute = createRootRoute({
  component: RootLayout,
  errorComponent: ErrorPage
});

export const appRoute = createRoute({
  id: 'app',
  getParentRoute: () => rootRoute,
  component: AppLayout,
  pendingComponent: LoaderPage,
  errorComponent: ErrorPage,
  beforeLoad: async () => {
    const result = await verifySession();

    if (!result?.data) {
      throw redirect({ to: '/sign-in' });
    }
  }
});
